<template>
  <div :class="$style.header">
    <div :class="$style.logo1Parent">
      <img :class="$style.logo1Icon" alt="" src="@/assets/logoYellow.svg" />
      <div class="routerLinks">
        <RouterLink to="/user">{{ $t('message.access_permit') }}</RouterLink>
        <RouterLink v-if="userStore.hasOperatorRights" to="/criteria">{{ $t('message.criteria') }}</RouterLink>
        <RouterLink v-if="userStore.hasOperatorRights" to="/process_requests">{{ $t('message.process_requests') }}</RouterLink>
      </div>
    </div>
    <div :class="$style.topRight">
      <LanguageSelectorContainer v-if="size.isDesktop.value" />
      <MenuSettings v-if="!size.isDesktop.value" />
      <MenuSettings v-if="size.isDesktop.value" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LanguageSelectorContainer from './LanguageSelectorContainer.vue'
import MenuSettings from '@/components/common/MenuSettings.vue'
import { useMonitorSize } from '@/composables/sizeMonitor'
import { useUserStore } from '@/stores/userStore';

export default defineComponent({
  name: 'TheHeader',
  setup() {
    const size = useMonitorSize();
    const userStore = useUserStore();
    return {
      size,
      userStore
    }
  },
  components: {
    LanguageSelectorContainer,
    MenuSettings
  }
})
</script>
<style>
.routerLinks {
  display: flex;
  gap: 16px;
}

.routerLinks a {
  text-transform: uppercase;
  text-decoration: none;
  color: #888888;
}

.routerLinks a.router-link-active {
  pointer-events: none;
  font-weight: 800;
  color: #ffffff;
}
</style>
<style module>
.topRight {
  display: flex;
  gap: 32px;
}

.logo1Icon {
  width: 110px;
  position: relative;
  height: 43px;
  overflow: hidden;
  flex-shrink: 0;
}

.accessPermitRequests {
  flex: 1;
  position: relative;
  line-height: 110%;
  text-transform: uppercase;
  font-weight: 600;
}

.languageIcon {
  width: 24px;
  position: relative;
  height: 24px;
}

.logo1Parent {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
}

.header {
  width: 100%;
  position: relative;
  background-color: var(--app-dark);
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  font-size: 16px;
  color: var(--app-white);
  font-family: Antarlida;
  padding: 0 16px;
  height: 60px;
  font-size: 16px;
}
.design-component-instance-node {
  flex: 0 0 auto !important;
}

@media (min-width: 768px) {
  .header {
    height: 100px;
    font-size: 18px;
    padding: 0 80px;
    height: 70px;
    font-size: 18px;
  }
}
</style>
